import { makeGetUserCoursesStatsGroupedByDateRanges } from "seneca-common/features/stats-review/state";

type UserId = string;

export function makeGetUserCoursesStatsGrouped(userId: UserId) {
  return makeGetUserCoursesStatsGroupedByDateRanges(userId);
}
